import React from 'react';

const SpecificAILogo = ({ style = {}, size = '18px' }) => (
    <img
        src="/images/brandmark_black.svg"
        alt="SpecificAI"
        style={{
            width: size,
            height: size,
            marginRight: '4px',
            verticalAlign: 'middle',
            ...style
        }}
    />
);

export default SpecificAILogo;
